import "./404.5974e111.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired08f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired08f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $hKdZU = parcelRequire("hKdZU");
parcelRequire("bWJvp");
console.debug("--- USING " + "production".toUpperCase() + " BUILD ---");
window.Alpine = (0, $hKdZU.default);
(0, $hKdZU.default).start();


//# sourceMappingURL=404.1db5d19a.js.map
